import React from 'react';
import { useTranslation } from 'react-i18next';

import { WebModal } from '@components/Modals/WebModal.web';
import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';

interface RemoveMemberConfirmModalProps {
  showModal: boolean;
  onClose?: () => void;
  onPress: () => void;
  buttonText: string;
  title: string;
  message: string | JSX.Element;
  memberName: string;
  isAlert?: boolean;
  cancelButtonText?: string;
}

export const RemoveMemberConfirmModal: React.FC<
  RemoveMemberConfirmModalProps
> = ({
  showModal,
  onClose,
  onPress,
  buttonText,
  title,
  message,
  memberName = '',
  isAlert = false,
  cancelButtonText = '',
}) => {
  const { t } = useTranslation();

  return (
    <WebModal
      marginHorizontal='l'
      title={title}
      onClose={onClose}
      visible={showModal}
      width={483}
      height={message !== '' ? 184 : undefined}>
      <>
        <Box flexDirection='row' marginHorizontal='l' marginVertical='l'>
          {message !== '' && (
            <Text variant='webBody' lineHeight={20}>
              {memberName !== '' && (
                <Text variant='webBody' fontWeight='bold'>
                  {memberName}
                </Text>
              )}
              {message}
            </Text>
          )}
        </Box>
        <Box
          flexDirection='row'
          flex={1}
          alignItems='flex-end'
          paddingHorizontal='l'
          mb='l'
          mt='l'
          alignSelf='flex-end'>
          {!isAlert && (
            <Button
              marginRight='m'
              onPress={onClose}
              borderColor='textPrimary'
              isSmall
              backgroundColor='white'>
              <Text variant='buttonLabel' color='textPrimary'>
                {cancelButtonText ? cancelButtonText : t('shared:cancel')}
              </Text>
            </Button>
          )}
          <Button
            onPress={onPress}
            borderColor='textPrimary'
            isSmall
            width={125}
            backgroundColor='black'>
            <Text variant='labelSmall' lineHeight={16} color='white'>
              {buttonText}
            </Text>
          </Button>
        </Box>
      </>
    </WebModal>
  );
};
